import React from 'react';
import MuiDrawer from '@mui/material/Drawer';

interface BottomSheetProps {
  open: boolean;
  onClose: (event: {}, reason: 'backdropClick' | 'escapeKeyDown') => void;
  paperStyle?: React.CSSProperties;
}

export const BottomSheet = ({
  open,
  onClose,
  paperStyle,
  children,
}: React.PropsWithChildren<BottomSheetProps>) => {
  return (
    <MuiDrawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      PaperProps={{ style: paperStyle }}
    >
      {children}
    </MuiDrawer>
  );
};
